/**
 * Backend Routing API Integration
 * Calls YOUR backend routing proxy (prevents CORS issues)
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5005';

/**
 * Normalize longitude to -180 to 180 range
 */
const normalizeLongitude = (lng) => {
    while (lng > 180) lng -= 360;
    while (lng < -180) lng += 360;
    return lng;
};

/**
 * Normalize coordinates to valid ranges
 */
const normalizeCoordinates = (coord) => {
    const normalized = {
        lat: Math.max(-90, Math.min(90, coord.lat)),
        lng: normalizeLongitude(coord.lng)
    };
    
    if (normalized.lng !== coord.lng) {
        console.log(`🔄 Normalized longitude: ${coord.lng.toFixed(2)}° → ${normalized.lng.toFixed(2)}°`);
    }
    
    return normalized;
};

/**
 * Fetch route via backend proxy
 * @param {object} start - {lat, lng}
 * @param {object} end - {lat, lng}
 * @param {string} profile - 'driving-car', 'driving-hgv', etc.
 * @param {number} alternatives - Number of alternative routes
 * @returns {Promise<array>} Array of routes
 */
export const fetchRouteViaBackend = async (start, end, profile = 'driving-car', alternatives = 1) => {
    try {
        console.log('🗺️  Fetching REAL routes via backend proxy...');
        
        // Normalize coordinates before sending
        const normalizedStart = normalizeCoordinates(start);
        const normalizedEnd = normalizeCoordinates(end);
        
        const response = await fetch(`${API_URL}/api/v1/routing/route`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-Key': process.env.REACT_APP_API_KEY || 'frac_d48567809b669980dc4fd133a106fee041784bac36b00dee6ab92a2326f9aad5'
            },
            body: JSON.stringify({
                start: normalizedStart,
                end: normalizedEnd,
                profile,
                alternatives
            })
        });
        
        if (!response.ok) {
            throw new Error(`Routing API returned ${response.status}`);
        }
        
        const result = await response.json();
        
        if (!result.success) {
            const errorMsg = result.message || result.error || 'Routing failed';
            console.error('Routing error details:', result.details);
            throw new Error(errorMsg);
        }
        
        console.log(`✅ Got ${result.data.length} routes from ${result.source}`);
        
        return result.data;
        
    } catch (error) {
        console.error('❌ Backend routing failed:', error);
        throw error;
    }
};


